import { render, staticRenderFns } from "./TextHead.vue?vue&type=template&id=055b3970&scoped=true&"
import script from "./TextHead.vue?vue&type=script&lang=js&"
export * from "./TextHead.vue?vue&type=script&lang=js&"
import style0 from "./TextHead.vue?vue&type=style&index=0&id=055b3970&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055b3970",
  null
  
)

export default component.exports